import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './ProductCard.css';
import { motion } from 'framer-motion';
import { addToCart } from "../../utils/addToCart";

export default function ProductCard({ product, isInWishlist = false, onWishlistToggle }) {
  const [hovered, setHovered] = useState(false);
  const [images, changeImage] = useState({main: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png", hovered: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png"})
  
  const setImage = () => {
    if (product.frontImage) {
      console.log(
        `product.image_url : ${product.frontImage} && product.image_url.startsWith("https") : ${product.frontImage.startsWith("https")}`,
      );
      if (product.frontImage.startsWith("https")) {
        changeImage({
          main: product.frontImage,
          hovered: product.backImage || product.frontImage,
        });
      } else {
      changeImage({main: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png", hovered: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png"})
    }
    } else {
      changeImage({main: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png", hovered: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png"})
    }
  }

  useEffect(() => {
    
    setImage();
  }, [product])

  
  return (
    <motion.div
      initial={{ opacity: 0, x: 30 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8 }}
      className="product-card"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <span className="tag-new">NEW</span>

      {/* Heart Icon for Wishlist */}
      {onWishlistToggle && (
        <button
          className={`heart-icon ${isInWishlist ? 'filled' : ''}`}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onWishlistToggle();
          }}
        >
          {isInWishlist ? '♥' : '♡'}
        </button>
      )}

      {/* Product Image */}
      <Link to={`/products/${product.slug}`}>
        <img
          src={hovered ? images.hovered : images.main}
          alt={product.title}
          className="product-image"
        />
      </Link>

      {/* Quick Add Box */}
      {hovered && (
        <div className="quick-add-box">
          <p className="quick-add-title">QUICK ADD</p>
          <div className="size-options">
            {Array.isArray(product.variants) && product.variants.length > 0 ? (
              product.variants.map((variant, index) => (
                <button key={index} className="size-btn" onClick={() => {
                  addToCart(product.id, 1, variant.variant_id)
                  console.log("Adding to cart (from product card) :", product.id, 1, variant.variant_id)
                }}>
                  {variant.size}
                </button>
              ))
            ) : (
              <button className="size-btn">+ ADD</button>
            )}
          </div>
        </div>
      )}

      {/* Product Info */}
      <div className="product-info">
        <Link to={`/products/${product.slug || product.id}`} className="product-title">
          {product.title}
        </Link>
        <p className="product-color">{product.color}</p>
        <p className="product-price">£{product.price}</p>
      </div>
    </motion.div>
  );
}
